'use client'

import { Input } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputEmail: SBDynamicFormInput = ({ ...rest }) => {
  return <Input type="email" autoComplete="email" {...rest} />
}

export { SBDynamicFormInputEmail }
